module.exports = __webpack_public_path__ + "img/wanwu_12.a2f5a9ae.png";